module.exports = __webpack_public_path__ + "static/media/FASNYLogoFinal.a1a00212.png";